import { render, staticRenderFns } from "./training_index.vue?vue&type=template&id=29c06620&scoped=true"
import script from "./training_index.vue?vue&type=script&lang=js"
export * from "./training_index.vue?vue&type=script&lang=js"
import style0 from "./training_index.vue?vue&type=style&index=0&id=29c06620&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c06620",
  null
  
)

export default component.exports